import React from 'react';
import { Check, X } from 'lucide-react';
import toast from 'react-hot-toast';

function Admin() {
  return (
    <div className="max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Photo Moderation</h2>
      
      <div className="grid gap-6">
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="text-center text-gray-600">
            This is a mockup version. The admin panel is not functional without a database connection.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Admin;